import { notification } from 'antd';
import { deleteOfferFx, fetchBuyerOffersListFx } from '../store/offers.store';
import md5 from 'md5';

export const handleDelete = async ({
  id,
  //setDisplayTooltip,
  type,
  company_name,
}: {
  id: number;
  // setDisplayTooltip: (val: boolean) => void;
  type: 'internal' | 'external';
  company_name: string;
}) => {
  try {
    const res: any = await deleteOfferFx(id as number);
    if ('error' in res) {
      const errorRes = await res?.error?.json() as any;
      const errorArray: any[] | null = errorRes.errors && Object.keys(errorRes.errors)?.reduce((result, key) => {
        return result.concat(errorRes.error?.errors[key]);
      }, []);
      if (errorArray && errorArray.length > 0) {
        errorArray.map((item) => notification.error({ message: item }));
        return;
      }
      if (typeof errorRes.error === 'string') {
        notification.error({ message: errorRes.error });
        return;
      }
      return notification.error({
        message: 'Непредвиденная ошибка. Попробуйте позже.',
      });
    }
    notification.success({ message: 'Предложение успешно удалено из системы!' });
    //setDisplayTooltip && setDisplayTooltip(false);
  } catch (err) {
    return notification.error({
      message: 'Непредвиденная ошибка. Попробуйте позже.',
    });
  } finally {
    fetchBuyerOffersListFx({
      id: id,
      md5: type === 'external' ? md5(company_name) : undefined,
    });
  }
};
